import { AfterContentInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';

@Directive({
    selector: '[caAutoFocus]',
})
export class AutoFocusDirective implements AfterContentInit, OnDestroy {
    @Input() caAutoFocus: boolean;

    timer: NodeJS.Timeout;

    constructor(private el: ElementRef) {}

    ngAfterContentInit() {
        // keep this condition as is, because applying a default value for caAutoFocus Input does not work
        if (this.caAutoFocus !== false) {
            this.timer = setTimeout(() => {
                this.el.nativeElement.focus();
            }, 50);
        }
    }

    ngOnDestroy() {
        // multiple detect changes can init this component multiple times in a row
        clearTimeout(this.timer);
    }
}
